/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
// actions
import {getClientEmailsData} from 'state/actions/reportsState/reports_status';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import AddableEmailList from 'material/addableemaillist/addableemaillist';



/* ========== ~~~~~~~~~~ FORM : FIELD : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({reportsState, sessionStatus}) => ({
    userEmail: sessionStatus.userEmail,
    allUsers: reportsState.reportsStatus.clientEmails.map((item, i)=> ({name: item.email, value: item.email})),
    usersPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('settings.users'),
    accountUUID: sessionStatus.accountUUID
});

// map state
const mapDispatchToProps = dispatch => ({
    getUsers: (accountUUID) => dispatch(getClientEmailsData(accountUUID)),
});

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddableEmailList);